import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function sliderTeachers() {
  new Swiper('.swiper-teachers', {
    modules: [Navigation],
    spaceBetween: 8,
    // loop: true,
    grabCursor: true,
    slidesPerView: 1.5,
    initialSlide: 1,
    navigation: {
      nextEl: ".teachers__slider .swiper-button-next",
      prevEl: ".teachers__slider .swiper-button-prev",
    },
    breakpoints: {
      600: {
        spaceBetween: 8,
        centeredSlides: true,
        slidesPerView: 2,
      },
      1110: {
        spaceBetween: 24,
        slidesPerView: 3,
        centeredSlides: true,
      }
    }
  });
}
sliderTeachers();